/**
 * Returns true if the session token will expire within the given buffer period.
 *
 * @param tokenExpiresAt - Unix timestamp in seconds (as returned by IVA's expires_at.to_i).
 *                         If undefined, returns false — the API will handle invalid tokens.
 * @param bufferSeconds  - How many seconds of runway to require before making an API call.
 *                         Defaults to 120 (2 minutes). This accounts for clock skew between
 *                         the client and IVA's server and ensures the token remains valid
 *                         for the duration of the API call.
 */
export function isTokenExpiringSoon(tokenExpiresAt: number | undefined, bufferSeconds = 120): boolean {
  if (tokenExpiresAt == null) return false;
  return tokenExpiresAt * 1000 < Date.now() + bufferSeconds * 1000;
}

